/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_SKINS',
  PUT: 'UPDATE_SKINS',
  DELETE: 'DELETE_SKINS',
};

export const appearanceSkinsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        action.payload,
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.index ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.findIndex((x) => x.id == action.index);
      newValues.splice(index, 1);
      return newValues;
    default:
      return state;
  }
};
